import { NavLink, Outlet } from 'react-router-dom';
import { useT } from '../i18n/I18nProvider';

export interface SectionTab {
  to: string;
  labelKey: string;
  /** Exact match — set on the index/list tab so it isn't active for child tabs. */
  end?: boolean;
}

/**
 * A destination that hosts several related views as tabs, so lower-frequency pages
 * live inside their parent rather than as separate sidebar entries (Phase 2.2 of the
 * navigation re-engineering). Tabs are route links: deep-linkable, back/forward
 * friendly, and marked with `aria-current` for assistive tech.
 */
export function TabbedSection({ tabs }: { tabs: SectionTab[] }): JSX.Element {
  const t = useT();
  return (
    <section>
      <nav className="page-tabs" aria-label="Section">
        {tabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            className={({ isActive }) => `page-tab${isActive ? ' active' : ''}`}
          >
            {t(tab.labelKey)}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </section>
  );
}
